import { getContent } from "../../../../../../../dependencies/getContent/dev";
import { getMapStateToSberPayCaptchaInputProps } from "./logic/logic";
import { getCaptchaImage } from "./dependencies/getCaptchaImage/dev";
import { refreshCaptcha } from "./dependencies/refreshCaptcha/dev";
import { sendSberpayPayment } from "../../../../../../../dependencies/submitPayment/methods/sberpay/index.regular";
export var mapStateToSberPayCaptchaInputProps = getMapStateToSberPayCaptchaInputProps({
  getCaptchaImage: getCaptchaImage,
  refreshCaptcha: refreshCaptcha,
  getContent: getContent,
  submitSberPayPayment: sendSberpayPayment
});